import { DirectUpload } from "@rails/activestorage";
import { BASE_URL } from "./api";

export function uploadToActiveStorage(file, onProgress) {
    return new Promise((resolve, reject) => {
        const token = localStorage.getItem("token");
        const uploadUrl = `${(BASE_URL || "").replace(/\/$/, "")}/api/v1/direct_uploads`;

        const delegate = {
            directUploadWillCreateBlobWithXHR: (xhr) => {
                if (token) {
                    xhr.setRequestHeader("Authorization", `Bearer ${token}`);
                }
            },
            directUploadWillStoreFileWithXHR: (xhr) => {
                if (onProgress) {
                    xhr.upload.addEventListener("progress", (event) => {
                        const progress = (event.loaded / event.total) * 100;
                        onProgress(progress);
                    });
                }
            }
        };

        const upload = new DirectUpload(file, uploadUrl, delegate);
        upload.create((error, blob) => {
            if (error) {
                reject(new Error(error));
            } else {
                resolve(blob);
            }
        });
    });
}
